import { useTranslation } from "react-i18next";
import {
  SFCircleIcon,
  SFCheckCircleIcon,
  SFCloudDoneIcon,
  SFTimelapseIcon,
} from "../../icons";
import { PAGE_TITLE_STATUS } from "../../../constants/actionBar";

/**
 * Retrieves the page title status templates based on the provided status.
 *
 * @param {string} status - The status of the page title.
 * @returns {Object} - The page title status template object.
 */
export const getPageTitleStatusTemplate = (status) => {
  const { t } = useTranslation();

  const statusTemplates = {
    [PAGE_TITLE_STATUS.ACTIVE]: {
      label: t("components.actionBar.pageTitleStatus.active"),
      icon: <SFCircleIcon color="green400" />,
    },
    [PAGE_TITLE_STATUS.MANUALLY_VERIFIED]: {
      label: t("components.actionBar.pageTitleStatus.manuallyUpdated"),
      icon: <SFCheckCircleIcon color="green400" />,
    },
    [PAGE_TITLE_STATUS.SYSTEM_VERIFIED]: {
      label: t("components.actionBar.pageTitleStatus.systemUpdated"),
      icon: <SFCloudDoneIcon color="green400" />,
    },
    [PAGE_TITLE_STATUS.PENDING]: {
      label: t("components.actionBar.pageTitleStatus.pending"),
      icon: <SFTimelapseIcon color="orange300" />,
    },
  };

  return statusTemplates[status];
};
